import React, { useState, useEffect } from "react";
import axios from "axios";
import "../App.css";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { acceptReport, rejectReport } from "../services/reactapis";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate, useLocation } from "react-router-dom";
import { ApiUrl } from '../Constants/Weburl'
import CustomTable from "../components/CustomTable";
import CustomButton from "../components/CustomButton";
import CustomSwitch from "../components/Customswitch";
import CustomPagination from '../components/Custompagination'
import CustomContainer from "../components/Customsettingscontain";
import CustomInput from '../components/Custominput';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Layout from '../components/Layout';
import useExpandableRows from "../components/useExpandableRows";
import useHiddenColumns from "../components/useHiddenFields";



export default function Users() {
  const [activeTab, setActiveTab] = useState("posts");
  const [alluser, setAllUsers] = useState([]);
  const [moderateusers, setModerateUsers] = useState([]);
  const [type, setType] = useState("post");
  const [search, setSearch] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const { toggleExpand, isExpanded } = useExpandableRows();

  const navigate = useNavigate();
  const location = useLocation();


  const currentUser = (() => {
    try {
      const stored =
        JSON.parse(localStorage.getItem("adminUser")) ||
        JSON.parse(localStorage.getItem("currentUser"));
      if (!stored) return null;
      const u = stored.user || stored;
      return { ...u, role: String(u.role || "").toLowerCase() };
    } catch {
      return null;
    }
  })();

  const isAdmin = currentUser?.role === "admin";
  const isModerator = currentUser?.role === "moderator";
  const isMe = (u) => String(u.id) === String(currentUser?.id);

  const getToken = () =>
    localStorage.getItem("adminToken");

  const canFreeze = (u) => {
    if (!currentUser || isMe(u)) return false;
    if (isAdmin) return true;
    if (isModerator) {
      if (u.role === "admin" || u.role === "moderator") return false;
      if (u.is_frozen) return false;
      return true;
    }
    return false;
  };

  // Admin mattum moderator role kudukkalam
  const canToggleModerator = (u) => isAdmin && !isMe(u);

  // console.log("currentUser:", currentUser, "| isAdmin:", isAdmin);




  const headers = [
    { label: "Profile", className: "col-profile" },
    { label: "Real", className: "col-real" },
    { label: "Identity", className: "col-identity", field: "identity" },
    { label: "Freeze", className: "col-freeze", field: "freeze" },
    { label: "Moderator", className: "col-moderator", field: "moderator" },
    { label: "Action", className: "col-action", field: "action" },
  ];


  const hiddenFields = useHiddenColumns(".rr1-table", headers);


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get('search');
    if (searchParam) {
      console.log("Search term from URL:", searchParam);
      setSearch(searchParam);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get('search');
    if (searchParam && searchParam !== search) {
      console.log("Search term updated from URL:", searchParam);
      setSearch(searchParam);
      setPage(1);
    }
  }, [location.search]);

  useEffect(() => {
    fetchAllUsers();
  }, [page, limit, search]);

  const fetchAllUsers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("adminToken");

      console.log("Fetching users with search:", search);

      const res = await axios.get(
        `${ApiUrl}api/auth/allusers?page=${page}&limit=${limit}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("API Response:", res.data);
      console.log("Filtered users count:", res.data.users?.length || 0);

      setAllUsers(res.data.users || []);
      setTotalPages(res.data.pagination?.totalPages || 1);
    } catch (e) {
      console.log("Error fetching users:", e.response?.data || e);
      setAllUsers([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (img) => {
    if (!img) return "";
    if (img.startsWith("http")) return img;
    return `${ApiUrl}${img.replace("\\", "/")}`;
  };

  const handleFreeze = async (u) => {
    if (!canFreeze(u)) return;
    try {
      await axios.put(
        `${ApiUrl}api/auth/users/${u.id}/freeze`,
        {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      fetchAllUsers();
      allmoderatorusers();
    } catch (e) {
      console.log("Error freezing user:", e.response?.data || e);
    }
  };

  const handleToggleModerator = async (u) => {
    if (!canToggleModerator(u)) return;
    try {
      await axios.put(
        `${ApiUrl}api/auth/users/${u.id}/toggle-moderator`,
        {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      fetchAllUsers();
      allmoderatorusers();
    } catch (err) {
      console.error("Error toggling moderator:", err.response?.data || err);
    }
  };

 
   const allmoderatorusers = async () => {
  try {
    const res = await axios.get(`${ApiUrl}api/auth/usermoderate`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    console.log("moderator users res:", res.data);
    setModerateUsers(res.data.data || []);
  } catch (e) {
    console.log("Error fetching moderator users:", e.response?.data || e);
    setModerateUsers([]);
  }
};
  useEffect(() => {
    allmoderatorusers();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setType(tab === "posts" ? "post" : "user");
    if (tab === "users") {
      setSearch("");
      setInputValue("");
      navigate(location.pathname, { replace: true });
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    setPage(1);

    const params = new URLSearchParams(location.search);
    if (value) {
      params.set('search', value);
    } else {
      params.delete('search');
    }
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  return (
    <div className="layout">

      <Layout>
        <CustomContainer className="rr-wrapperhashtag" fluid="false">


          <div className="rr-card">
            {/* ── Tabs row ── */}
            <div className="users-tabs-row">
              <div className="activetab">
                <CustomButton
                  className={activeTab === "posts" ? "tab active" : "tab"}
                  onClick={() => handleTabChange("posts")}
                >
                  Users
                </CustomButton>
                <CustomButton
                  className={activeTab === "users" ? "tab active" : "tab"}
                  onClick={() => handleTabChange("users")}
                >
                  Moderator
                </CustomButton>
              </div>

              {/* ── Show entries + Search controls ── */}
              <div className="users-controls">
                <div className="rr-left">
                  Show
                  <select
                    className="rr-select"
                    value={limit}
                    onChange={(e) => {
                      setLimit(Number(e.target.value));
                      setPage(1);
                    }}
                  >
                    <option>5</option>
                    <option>10</option>
                    <option>25</option>
                    <option>50</option>
                  </select>
                  entries
                </div>

                <div className="rr-right">
                  <span>Search:</span>
                  <CustomInput
                    className="rr-search"
                    type="text"
                    value={inputValue}
                    onChange={handleSearchChange}
                    placeholder="Search Users"
                  />
                </div>
              </div>
            </div>



            {/* {activeTab === "posts" && (
              <CustomTable headers={headers} className="rr1-table table">
                {loading ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
                      Loading...
                    </td>
                  </tr>
                ) : alluser.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
                      {search ? `No users found matching "${search}"` : "No users found"}
                    </td>
                  </tr>
                ) : (
                  alluser.map((u) => (
                    <React.Fragment key={u.id}>
                      <tr className="rr-actionshastag">
                        <td className="col-profile rr-actions1">
                          <div className="profile-pill">
                            {hiddenFields.length > 0 && (
                              <button
                                type="button"
                                className={`row-expand-toggle ${isExpanded(u.id) ? "is-open" : ""}`}
                                onClick={() => toggleExpand(u.id)}
                                aria-label="Show more details"
                              >
                                {isExpanded(u.id) ? "−" : "+"}
                              </button>
                            )}
                            <div className="avatar">
                              <img
                                src={getImageUrl(u.avatar)}
                                alt=""
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                            <div>
                              <div className="username">{u.username}</div>
                              <div className="subtext">{u.name || ""}</div>
                            </div>
                          </div>
                        </td>
                        <td className="col-real">
                          <span className="real-badge">Real</span>
                        </td>
                        <td className="col-identity rr-actions1">{u.email}</td>
                        <td className="col-freeze">
                          <CustomSwitch
                            checked={Boolean(u.is_frozen)}
                            onChange={() => handleFreeze(u.id)}
                          />
                        </td>
                        <td className="col-moderator">
                          <CustomSwitch
                            checked={u.role === "moderator"}
                            onChange={() => handleToggleModerator(u.id)}
                          />
                        </td>
                        <td className="col-action" style={{ textAlign: 'center' }}>
                          <CustomButton
                            className="eye-btn"
                            onClick={() => navigate(`/Userview/${u.id}`)}
                          >
                            <FaEye size={14} color="gray" />
                          </CustomButton>
                        </td>
                      </tr>


                      {isExpanded(u.id) && hiddenFields.length > 0 && (
                        <tr className="row-expand-details">
                          <td colSpan={6}>
                            <div className="expand-details">
                              {hiddenFields.map(({ field, label }) => (
                                <div className="expand-item" key={field}>
                                  <span className="expand-label">{label}</span>
                                  {field === "identity" && (
                                    <span className="expand-value">{u.email}</span>
                                  )}
                                  {field === "freeze" && (
                                    <CustomSwitch
                                      checked={Boolean(u.is_frozen)}
                                      onChange={() => handleFreeze(u.id)}
                                    />
                                  )}
                                  {field === "moderator" && (
                                    <CustomSwitch
                                      checked={u.role === "moderator"}
                                      onChange={() => handleToggleModerator(u.id)}
                                    />
                                  )}
                                  {field === "action" && (
                                    <CustomButton
                                      className="eye-btn"
                                      onClick={() => navigate(`/Userview/${u.id}`)}
                                    >
                                      <FaEye size={14} color="gray" />
                                    </CustomButton>
                                  )}
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      )}

                    </React.Fragment>
                  ))
                )}
              </CustomTable>
            )} */}


            {activeTab === "posts" && (
  <CustomTable headers={headers} className="rr1-table table">
    {loading ? (
      <tr>
        <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
          Loading...
        </td>
      </tr>
    ) : alluser.length === 0 ? (
      <tr>
        <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
          {search ? `No users found matching "${search}"` : "No users found"}
        </td>
      </tr>
    ) : (
      alluser.map((u) => (
        <React.Fragment key={u.id}>
          <tr className="rr-actionshastag">
            <td className="col-profile rr-actions1">
              <div className="profile-pill">
                {hiddenFields.length > 0 && (
                  <button
                    type="button"
                    className={`row-expand-toggle ${isExpanded(u.id) ? "is-open" : ""}`}
                    onClick={() => toggleExpand(u.id)}
                    aria-label="Show more details"
                  >
                    {isExpanded(u.id) ? "−" : "+"}
                  </button>
                )}
                <div className="avatar" onClick={() => navigate(`/Userview/${u.id}`)}>
                  <img
                    src={getImageUrl(u.avatar)}
                    alt=""
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div>
                  <div className="username">{u.username}</div>
                  <div className="subtext">{u.name || ""}</div>
                </div>
              </div>
            </td>
            <td className="col-real">
              <span className="real-badge">Real</span>
            </td>
            <td className="col-identity rr-actions1">{u.email}</td>
            <td className="col-freeze">
              <CustomSwitch
                checked={Boolean(u.is_frozen)}
                disabled={!canFreeze(u)}
                onChange={() => handleFreeze(u)}
              />
            </td>
            <td className="col-moderator">
              <CustomSwitch
                checked={u.role === "moderator"}
                disabled={!canToggleModerator(u)}
                onChange={() => handleToggleModerator(u)}
              />
            </td>
            <td className="col-action" style={{ textAlign: "center" }}>
              <CustomButton
                className="eye-btn"
                onClick={() => navigate(`/Userview/${u.id}`)}
              >
                <FaEye size={14} color="gray" />
              </CustomButton>
            </td>
          </tr>

          {isExpanded(u.id) && hiddenFields.length > 0 && (
            <tr className="row-expand-details">
              <td colSpan={6}>
                <div className="expand-details">
                  {hiddenFields.map(({ field, label }) => (
                    <div className="expand-item" key={field}>
                      <span className="expand-label">{label}</span>
                      {field === "identity" && (
                        <span className="expand-value">{u.email}</span>
                      )}
                      {field === "freeze" && (
                        <CustomSwitch
                          checked={Boolean(u.is_frozen)}
                          disabled={!canFreeze(u)}
                          onChange={() => handleFreeze(u)}
                        />
                      )}
                      {field === "moderator" && (
                        <CustomSwitch
                          checked={u.role === "moderator"}
                          disabled={!canToggleModerator(u)}
                          onChange={() => handleToggleModerator(u)}
                        />
                      )}
                      {field === "action" && (
                        <CustomButton
                          className="eye-btn"
                          onClick={() => navigate(`/Userview/${u.id}`)}
                        >
                          <FaEye size={14} color="gray" />
                        </CustomButton>
                      )}
                    </div>
                  ))}
                </div>
              </td>
            </tr>
          )}
        </React.Fragment>
      ))
    )}
  </CustomTable>
)}

            {/* {activeTab === "users" && (
              <div className="users-table">
                <div className="users-header">
                  <span>Profile</span>
                  <span>Real</span>
                  <span>Identity</span>
                  <span>Freeze</span>
                  <span>Moderator</span>
                  <span>Action</span>
                </div>
                {moderateusers.map((m) => (
                  <div className="users-row" key={m.id}>
                    <div className="profile-pill">
                      <div className="avatar">
                        <img
                          src={getImageUrl(m.avatar)}
                          alt=""
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                      <div>
                        <div className="username">{m.username}</div>
                        <div className="subtext">{m.name || ""}</div>
                      </div>
                    </div>
                    <span className="real-badge">Real</span>
                    <span className="email">{m.email}</span>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={m.is_frozen}
                        disabled={
                          m.id === currentUser?.id ||
                          (currentUser?.role === 'moderator' &&
                            (m.role === 'admin' || m.role === 'moderator')) ||
                          (currentUser?.role === 'moderator' && m.is_frozen)
                        }
                        onChange={() => handleFreeze(m.id)}
                      />
                      <span className="slider"></span>
                    </label>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={m.role === "moderator"}
                        disabled={
                          currentUser?.role !== "admin" ||
                          m.id === currentUser?.id
                        }
                        onChange={() => handleToggleModerator(m.id)}
                      />
                      <span className="slider"></span>
                    </label>
                    <CustomButton className="eye-btn" onClick={() => navigate(`/Userview/${m.id}`)}>
                      👁
                    </CustomButton>
                  </div>
                ))}
              </div>
            )} */}


            {activeTab === "users" && (
              <CustomTable headers={headers} className="rr1-table table">
                {moderateusers.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
                      No moderators found
                    </td>
                  </tr>
                ) : (
                  moderateusers.map((m) => (
                    <React.Fragment key={m.id}>
                      <tr className="rr-actionshastag">
                        <td className="col-profile rr-actions1">
                          <div className="profile-pill">
                            {hiddenFields.length > 0 && (
                              <button
                                type="button"
                                className={`row-expand-toggle ${isExpanded(m.id) ? "is-open" : ""}`}
                                onClick={() => toggleExpand(m.id)}
                                aria-label="Show more details"
                              >
                                {isExpanded(m.id) ? "−" : "+"}
                              </button>
                            )}
                            <div className="avatar">
                              <img
                                src={getImageUrl(m.avatar)}
                                alt=""
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                            <div>
                              <div className="username">{m.username}</div>
                              <div className="subtext">{m.name || ""}</div>
                            </div>
                          </div>
                        </td>
                        <td className="col-real">
                          <span className="real-badge">Real</span>
                        </td>
                        <td className="col-identity rr-actions1">{m.email}</td>
                        <td className="col-freeze">
                          <CustomSwitch
                            checked={Boolean(m.is_frozen)}
                            disabled={!canFreeze(m)}
                            onChange={() => handleFreeze(m)}
                          />
                        </td>
                        <td className="col-moderator">
                          <CustomSwitch
                            checked={m.role === "moderator"}
                            disabled={!canToggleModerator(m)}
                            onChange={() => handleToggleModerator(m)}
                          />
                        </td>
                        <td className="col-action" style={{ textAlign: "center" }}>
                          <CustomButton
                            className="eye-btn"
                            onClick={() => navigate(`/Userview/${m.id}`)}
                          >
                            <FaEye size={14} color="gray" />
                          </CustomButton>
                        </td>
                      </tr>

                      {isExpanded(m.id) && hiddenFields.length > 0 && (
                        <tr className="row-expand-details">
                          <td colSpan={6}>
                            <div className="expand-details">
                              {hiddenFields.map(({ field, label }) => (
                                <div className="expand-item" key={field}>
                                  <span className="expand-label">{label}</span>
                                  {field === "identity" && (
                                    <span className="expand-value">{m.email}</span>
                                  )}
                                  {field === "freeze" && (
                                    <CustomSwitch
                                      checked={Boolean(m.is_frozen)}
                                      disabled={!canFreeze(m)}
                                      onChange={() => handleFreeze(m)}
                                    />
                                  )}
                                  {field === "moderator" && (
                                    <CustomSwitch
                                      checked={m.role === "moderator"}
                                      disabled={!canToggleModerator(m)}
                                      onChange={() => handleToggleModerator(m)}
                                    />
                                  )}
                                  {field === "action" && (
                                    <CustomButton
                                      className="eye-btn"
                                      onClick={() => navigate(`/Userview/${m.id}`)}
                                    >
                                      <FaEye size={14} color="gray" />
                                    </CustomButton>
                                  )}
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                )}
              </CustomTable>
            )}

            <div className="rr-footer">
              {activeTab === "posts" && (
                <>
                  <span>
                    Showing {alluser.length > 0 ? 1 : 0} to {alluser.length} of {alluser.length} entries
                  </span>
                  <CustomPagination
                    currentPage={page}
                    totalPages={totalPages}
                    onPageChange={(page) => setPage(page)}
                    className="rr-pagination"
                    pageClassName="rr-page"
                    activeClassName="active"
                    ellipsisClassName="rr-page"
                  />
                </>
              )}
              {activeTab === "users" && (
                <span>
                  Showing {moderateusers.length > 0 ? 1 : 0} to {moderateusers.length} of {moderateusers.length} entries
                </span>
              )}
            </div>
          </div>
        </CustomContainer>
      </Layout>
      {/* </main> */}
    </div>
  );
}